export const URL_REPORTS_MOPC_SERVICE_LOCATION_COUNT = 'mopc-service-location-count';
export const URL_REPORTS_MOPC_LOCATION_NAME_COUNT = 'mopc-location-name-count';
export const URL_REPORTS_MOPC_ACTIVITY_MEDIUM_OVERVIEW = 'mopc-activity-medium-overview';
export const URL_REPORTS_MOPC_ACTIVITY_COUNT = 'mopc-activity-count';
export const URL_HMP = 'hmp';
export const URL_HMP_SUMMARY = 'hmp-summary';
export const URL_FTF = 'ftf-report';
export const URL_MBF = 'mbf';
export const URL_DRP = 'drp';
export const URL_TCR = 'tcr';
export const URL_REMAP_PARTICIPANT = 'remap-participant-data';
export const URL_REMAP_CASE = 'remap-case';
export const URL_REMAP_INFO_SESSION = 'remap-info-session';
export const URL_MOPC_DEMOGRAPHICS = 'mopc-demographics';
export const URL_MOPC_DEMOGRAPHICS_LOCATIONS = 'mopc-demographics-locations';
export const URL_MOPC_USER_COUNT = 'mopc-user-counts';
export const URL_MOPC_USER_DETAILS = 'mopc-user-details';
export const URL_CR_ACTIVITY_SUMMARY = 'mopc-cr-activity-summary';
export const URL_CR_CLOSED_ACTIVITIES = 'mopc-cr-closed-activities';
export const URL_ENTITY_NAMES = 'mopc-entity-names';
export const URL_ENTITY_TYPES = 'mopc-entity-types';
export const URL_DISPOSITION_DISPUTE = 'mopc-disposition-dispute';
export const URL_DISPOSITION_ENTITY = 'mopc-disposition-entity';
export const URL_MOPC_OUTREACH = 'mopc-outreach';
